import {Dispatch} from "redux";
import {ErrorDto, getErrorDtoFromApiError} from "../../../models/dtos/error.dto";
import {LeaderboardDto} from "../../../models/dtos/leaderboard.dto";
import {
  GET_LEADERBOARD_FAIL,
  GET_LEADERBOARD_RESET,
  GET_LEADERBOARD_START,
  GET_LEADERBOARD_SUCCESS,
} from "./constants";
import {getLeaderboardRequest} from "./repository";
import {
  GetLeaderboardFailAction,
  GetLeaderboardResetAction,
  GetLeaderboardStartAction,
  GetLeaderboardSuccessAction,
} from "./types";

const getLeaderboardStartAction = (): GetLeaderboardStartAction => {
  return {
    type: GET_LEADERBOARD_START,
  };
}
const getLeaderboardSuccessAction = (payload: LeaderboardDto): GetLeaderboardSuccessAction => {
  return {
    type: GET_LEADERBOARD_SUCCESS,
    payload: payload,
  };
}
const getLeaderboardFailAction = (error: ErrorDto): GetLeaderboardFailAction => {
  return {
    type: GET_LEADERBOARD_FAIL,
    error: error,
  };
}
const getLeaderboardResetAction = (): GetLeaderboardResetAction => {
  return {
    type: GET_LEADERBOARD_RESET,
  };
}

export const getLeaderboard = () => async (
  dispatch: Dispatch
) => {
  try {
    dispatch(getLeaderboardStartAction());
    const response = await getLeaderboardRequest();
    dispatch(getLeaderboardSuccessAction(response));
  } catch (error) {
    dispatch(getLeaderboardFailAction(getErrorDtoFromApiError(error)));
  }
};

export const getLeaderboardReset = () => (
  dispatch: Dispatch
) => {
  dispatch(getLeaderboardResetAction());
};
